import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const DeleteLandingPageLocationModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteLandingPageLocationModalContainer" */
      './DeleteLandingPageLocationModalContainer'
    ),
  loading: LoadingModal,
});
